import { type FC, useMemo } from 'react';
import { Button, Container } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { PinMap } from 'react-bootstrap-icons';

import './styles/styles.css';

interface ParkingGuideModalProps {
  show: boolean;
  handleClose: () => void;
  parkingGuideUrl: string;
}

/**
 * Converts Google My Maps URLs (edit/viewer) to their embeddable format.
 * e.g. https://www.google.com/maps/d/u/0/edit?mid=ID&usp=sharing
 *   -> https://www.google.com/maps/d/embed?mid=ID
 */
const toEmbedUrl = (url: string): string => {
  const myMapsMatch = url.match(
    /google\.com\/maps\/d\/(?:u\/\d+\/)?(edit|viewer)\?mid=([^&]+)/,
  );
  if (myMapsMatch) {
    return `https://www.google.com/maps/d/embed?mid=${myMapsMatch[2]}`;
  }
  return url;
};

export const ParkingGuideModal: FC<ParkingGuideModalProps> = ({
  show,
  handleClose,
  parkingGuideUrl,
}) => {
  const embedUrl = useMemo(() => toEmbedUrl(parkingGuideUrl), [parkingGuideUrl]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="post-editor-modal modal-200w"
      backdrop="static"
      id="guest-portal"
      centered
    >
      <Modal.Header className="guest-modal-header">
        <Modal.Title className="editor-title">
          <PinMap size={20} style={{ marginRight: '8px' }} /> Parking Guide
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="guest-modal-header">
        <iframe
          src={embedUrl}
          width="100%"
          height="450px"
          style={{ border: 'none', borderRadius: '8px' }}
          title="Parking Guide Map"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <div style={{ textAlign: 'center', marginTop: '12px' }}>
          <a
            href={parkingGuideUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--primary-button-color)', fontSize: '14px' }}
          >
            Open in Google Maps
          </a>
        </div>
      </Modal.Body>
      <Container className="guest-modal-footer">
        <Button className="cancel-button no-border-radius" onClick={handleClose}>
          Close
        </Button>
      </Container>
    </Modal>
  );
};
